import { css } from "@dna/react";
import React from "react";

export interface IFacilityDisplayProps {
    organisationName: string | null | undefined,
    facilityName: string | null | undefined
}

export const FacilityDisplay = (props: IFacilityDisplayProps) => {

    var displayText = '';
    if (!props.organisationName && !props.facilityName) {
        displayText = '';
    }
    else if (!props.organisationName && props.facilityName) {
        displayText = props.facilityName;
    }
    else if (!props.facilityName && props.organisationName) {
        displayText = props.organisationName;
    }
    else {
        displayText = `${props.organisationName}, ${props.facilityName}`
    }


    return (
        <div className={css({ })}>
            {displayText}
        </div>
    );
};
